import EditComponent from './BranchStoreUserEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import { useRef } from 'react';

//组件 
const WebComponents = (props: any) => {
    /** api服务id */
    const apiId = 'branchStoreUser';
    const { branchStoreId, closeModal } = props;

    const ref = useRef<any>(undefined);
    const handleOk = (e: any) => {
        closeModal(true);
    };
    //表头
    const columnsHead = [
        {
            title: '餐饮服务类型',
            dataIndex: 'cateringServiceTypeId'
        },
        {
            title: '分店',
            dataIndex: 'branchStore',
            render: (text: any) => (text?.branchStoreName)
        },
        {
            title: '用户',
            dataIndex: 'user',
            render: (text: any) => (text?.userName)
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '服务',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        sendPageData: { branchStoreId },
        EditComponent
    };

    return (
        <div>
            <AntDraggableModal
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleOk}
                closable={false}
                maskClosable={false}
                width={1000}>
                <WebUniversal props={extendProps} ref={ref}></WebUniversal>
            </AntDraggableModal>
        </div>
    )
}

export default WebComponents;
